import { useMemo } from 'react';

import type { Organization } from '@rtkwlf/eloc';
import { useTranslation } from 'react-i18next';

import {
  AutocompleteSimple,
  type AutocompleteSimpleOption,
} from '@packages/fenrir/components/autocomplete/autocomplete-simple';

type OrganizationsAutocompleteProps = {
  organization?: AutocompleteSimpleOption['value'];
  onOrganizationChange?: (
    organization: AutocompleteSimpleOption['value'],
  ) => void;
  width?: number | string;
  organizations: Organization[];
};

export const OrganizationsAutocomplete = ({
  organizations,
  onOrganizationChange,
  organization,
  width,
}: OrganizationsAutocompleteProps) => {
  const { t } = useTranslation('app', {
    keyPrefix: 'organizations.organizationSwitcher.autocomplete',
  });

  const options = useMemo(() => {
    if (!organizations) return [];

    return organizations.map((org) => ({
      label: org.name,
      value: org.id,
    }));
  }, [organizations]);

  const value = organization
    ? options.find((option) => option.value === organization)
    : undefined;

  return (
    <AutocompleteSimple
      value={value}
      options={options}
      label={t('label')}
      hideLabel
      placeholder={t('placeholder')}
      onChange={(_, item) => {
        if (!item) return;

        onOrganizationChange?.(item.value);
      }}
      sx={{ width }}
    />
  );
};
